// extracted by mini-css-extract-plugin
export default {"icon":"icon-module--icon--32383"};